<template>
  <div>
    <el-dialog
      :visible.sync="dialogdata"
      width="700px"
      :title="title"
      :close-on-click-modal="false"
      @open="opendialog"
    >
      <div class="mydia">
        <div style="margin-bottom:20px">
          <span>到期日期</span>
          <span
            v-if="isEdit==2"
            style="margin-left:12px"
          >{{date}}</span>
          <el-date-picker
            v-else
            v-model="date"
            type="date"
            placeholder="选择日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            style="margin-left:10px;width:180px"
          >
          </el-date-picker>
        </div>
        <div>
          <div class="flex">
            <div style="width:67px">保单</div>
            <span style="color:gray">最多上传5张图片</span>
          </div>
          <div class="imgbox">
            <div
              v-for="(item,index) in imgList"
              :key="index"
              class="img_item"
            >
              <el-image
                :src="item"
                class="img"
                :preview-src-list="imgList"
              >
              </el-image>
              <el-button
                type="text"
                icon="el-icon-delete"
                class="delicon"
                @click="delImg(index)"
                v-if="isEdit!=2"
              ></el-button>
            </div>
            <div
              class="uploadimg"
              v-if="imgList.length<5&&isEdit!=2"
            >
              <el-upload
                name="image"
                accept=".png,.jpeg,.jpg"
                :action="uploadUrl"
                :data="uploadExtraData"
                :headers="uploadHeaders"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <div class="uploader-icon">
                  <div>
                    <i
                      class="el-icon-plus"
                      style="font-size: 25px"
                    ></i>
                  </div>
                  <el-button
                    type="text"
                    size="medium"
                  >添加图片</el-button>
                  <div style="color: #b0babc; font-size: 12px">
                    支持jpg、png、jpeg格式
                  </div>
                </div>
              </el-upload>
            </div>
          </div>
        </div>
        <div
          style="margin-top: 40px;text-align:center"
          v-if="isEdit!=2"
        >
          <el-button
            plain
            size="medium"
            style="width: 92px"
            @click="dialogdata=false"
          >取消</el-button>
          <el-button
            type="primary"
            size="medium"
            style="width: 92px"
            @click="sumbit"
          >确定</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import dayjs from 'dayjs';
import constant from '../../../service/common/constant';

export default {
  data() {
    return {
      dialogdata: false,
      uploadExtraData: {
        img_type: 4,
        suffix: '.jpg'
      },
      title: '上传保单信息',
      date: '',
      imgList: [],
      uploadList: []
    };
  },
  watch: {
    isFlag() {
      this.dialogdata = true;
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    uploadUrl() {
      if (process.env.NODE_ENV == 'development') {
        // 本地开发使用 api 前缀
        return 'api/platform/upload/uploadFile';
      } else {
        return 'platform/upload/uploadFile';
      }
    },
    uploadHeaders: function () {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ['version', 'platform', 'appid']),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken
        }
      );
    }
  },
  props: ['isFlag', 'doctorId', 'isEdit'],
  methods: {
    close() {
      this.dialogdata = false;
    },
    opendialog() {
      if (this.isEdit == 0) {
        this.title = '上传保单信息';
        this.date = '';
        this.imgList = [];
        this.uploadList = [];
      }
      if (this.isEdit == 1) {
        this.title = '编辑保单信息';
        this.getDetail();
      }
      if (this.isEdit == 2) {
        this.title = '查看保单信息';
        this.getDetail();
      }
    },
    getDetail() {
      let doctor_id = this.doctorId;
      this.axios
        .post('platform/Doctor/doctorSafeDetail', { doctor_id })
        .then((res) => {
          if (res.code == 0) {
            let info = res.data.info;
            this.date = dayjs.unix(info.expire_time).format('YYYY-MM-DD');
            this.imgList = info.safe_img_str;
            this.uploadList = info.safe_img.split(',');
          }
        });
    },
    //提交
    sumbit() {
      if (!this.date || !this.imgList.length) {
        this.$message.error('请完善保单信息!');
        return false;
      }
      let data = {
        doctor_id: this.doctorId,
        expire_time: this.date,
        safe_img: this.uploadList.toString()
      };
      this.axios.post('platform/Doctor/saveSafeImg', data).then((res) => {
        if (res.code == 0) {
          this.$message.success('上传成功');
          this.dialogdata = false;
          this.$emit('refreshList');
        }
      });
    },
    //删除图片
    delImg(index) {
      this.imgList.splice(index, 1);
      this.uploadList.splice(index, 1);
    },
    //上传成功
    handleAvatarSuccess(res) {
      if (res.code === 0) {
        this.imgList.push(res.data.path);
        this.uploadList.push(res.data.pic);
      }
    },
    dataURItoFile(dataurl, filename) {
      let arr = dataurl.split(',');
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },

    beforeAvatarUpload(file) {
      const supportImgTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      const isSupportType = _.indexOf(supportImgTypes, file.type) !== -1;
      if (!isSupportType) {
        this.$message.error('上传图片只能是 jpg, png, jpeg 格式!');
        return false;
      }
      const suffix = file.name.substring(file.name.lastIndexOf('.'));
      this.uploadExtraData.suffix = suffix;
      this.uploadExtraData.img_type = 4;
      this.uploadHeaders.timestamp = Date.now();
      const _this = this;
      return new Promise((resolve) => {
        const reader = new FileReader();
        const image = new Image();
        image.onload = (imageEvent) => {
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          const width = 750;
          const height = (750 / image.width) * image.height;
          canvas.width = width;
          canvas.height = height;
          context.clearRect(0, 0, width, height);
          context.drawImage(image, 0, 0, width, height);
          const dataUrl = canvas.toDataURL(file.type);
          const blobData = _this.dataURItoFile(dataUrl, file.name);
          resolve(blobData);
        };
        reader.onload = (e) => {
          image.src = e.target.result;
        };
        reader.readAsDataURL(file);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.mydia {
  text-align: left;
  padding: 20px;
}
.imgbox {
  display: flex;
  box-sizing: border-box;
  flex-wrap: wrap;
  margin-top: 10px;
  margin-left: 67px;
}
.img {
  width: 180px;
  height: 180px;
  margin: 0 10px 10px 0;
}
.img_item {
  position: relative;
  .delicon {
    position: absolute;
    color: #fff;
    font-size: 30px;
    font-weight: 700;
    top: 0px;
    left: 140px;
  }
}
.uploadimg {
  width: 180px;
  height: 180px;
  box-sizing: border-box;
  background-color: #fff;
  border: dashed 1px #d6d6d6;
  text-align: center;
  .avatar {
    width: 180px;
    height: 180px;
  }
  .uploader-icon {
    padding-top: 30px;
    line-height: 30px;
    color: #669961;
  }
}
</style>